"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Camera, Video, Calendar, Package, Smartphone, Pen } from "lucide-react";
const services = [{
  icon: Video,
  title: "Video Production",
  bullets: ["Pre-production planning and storyboarding", "Professional filming with cinematic quality", "Expert editing, color grading, and sound design"]
}, {
  icon: Camera,
  title: "Photography",
  bullets: ["Studio and on-location shoots", "Product, portrait, and commercial photography", "High-resolution images with professional retouching"]
}, {
  icon: Calendar,
  title: "Event Coverage",
  bullets: ["Comprehensive photo and video packages", "Live event documentation", "Fast turnaround for time-sensitive deliverables"]
}, {
  icon: Package,
  title: "Product Shoots",
  bullets: ["E-commerce ready product photography", "Lifestyle and contextual shots", "360° product views and animations"]
}, {
  icon: Smartphone,
  title: "Social Media Content",
  bullets: ["Reels, TikTok, and Snap format videos", "Platform-optimized vertical content", "Engaging short-form storytelling"]
}, {
  icon: Pen,
  title: "Post-Production",
  bullets: ["Professional video editing and assembly", "Advanced color grading and correction", "Motion graphics and visual effects"]
}];
export default function ServiceDetails() {
  const {
    ref: ref0,
    isVisible: isVisible0
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const {
    ref: ref5,
    isVisible: isVisible5
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const refs = [ref0, ref1, ref2, ref3, ref4, ref5];
  const visibilities = [isVisible0, isVisible1, isVisible2, isVisible3, isVisible4, isVisible5];
  return <section id="service-details" className="py-24 px-6 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className="space-y-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] px-6 py-8">
                  <CardContent className="p-0">
                    <div className="flex items-start gap-6">
                      <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-md bg-accent/10">
                        <Icon className="w-6 h-6" style={{
                      color: "var(--color-accent)"
                    }} />
                      </div>
                      <div className="flex-1 space-y-4">
                        <div>
                          <h3 className="text-xl font-display font-semibold text-foreground mb-2">
                            {service.title}
                          </h3>
                          <Separator className="w-16 h-0.5 bg-accent" />
                        </div>
                        <ul className="space-y-2">
                          {service.bullets.map((bullet, idx) => <li key={idx} data-index={idx} className="text-sm text-muted-foreground flex items-start gap-2">
                              <span className="mt-1.5 w-1 h-1 rounded-full bg-accent flex-shrink-0" />
                              <span>{bullet}</span>
                            </li>)}
                        </ul>
                        <Link to="#pricing" className="inline-flex items-center text-sm font-semibold group transition-all duration-[var(--duration-fast)] hover:-translate-y-0.5" style={{
                      color: "var(--color-accent)"
                    }}>
                          Learn More
                          <svg className="w-4 h-4 ml-1 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}